import * as actions from './actions';

export interface WorkflowOverlayState {
    activeTabIndex: number;
    primaryActionName: string;
    isProcessing: boolean;
    numberOfCandidatesWithMissingGrade: number;
    hasCandidateJustBeenShared: boolean;
    hasCandidateJustBeenConfirmed: boolean;
    hasCandidateJustBeenUnshared: boolean;
    hasCandidateJustBeenUnconfirmed: boolean;
    hasCandidateJustBeenSharedOnBehalf: boolean;
    hasCandidateJustBeenConfirmedOnBehalf: boolean;
    hasCandidateJustBeenUnsharedOnBehalf: boolean;
    hasCandidateJustBeenUnconfirmedOnBehalf: boolean;
    hasCandidateJustBeenReopenMarking: boolean;
}

export const workflowTabs = {
    SHARE: { index: 0, name: 'grading.workflow.tabs.share' },
    ALIGN: { index: 1, name: 'grading.workflow.tabs.align' },
    CONFIRM: { index: 2, name: 'grading.workflow.tabs.confirm' },
    SETUP: { index: 3, name: 'Setup' },
    MEMBERS: { index: 4, name: 'Members' },
};

const initialState: WorkflowOverlayState = {
    activeTabIndex: null,
    primaryActionName: '',
    isProcessing: false,
    numberOfCandidatesWithMissingGrade: 0,
    hasCandidateJustBeenShared: false,
    hasCandidateJustBeenConfirmed: false,
    hasCandidateJustBeenUnshared: false,
    hasCandidateJustBeenUnconfirmed: false,

    hasCandidateJustBeenSharedOnBehalf: false,
    hasCandidateJustBeenConfirmedOnBehalf: false,
    hasCandidateJustBeenUnsharedOnBehalf: false,
    hasCandidateJustBeenUnconfirmedOnBehalf: false,
    hasCandidateJustBeenReopenMarking: false,
};

export function getReducer(featureId: string) {
    return (
        state: WorkflowOverlayState = initialState,
        action: actions.ActionTypes,
    ): WorkflowOverlayState => {
        if (action.featureId !== featureId) {
            return state;
        }

        switch (action.type) {
        case actions.TypeKeys.ON_TAB_CHANGE:
            return {
                ...state,
                activeTabIndex: action.activeIndex,
            };
        case actions.TypeKeys.TOGGLE_PROCESSING:
            return {
                ...state,
                isProcessing: !state.isProcessing,
            };
        case actions.TypeKeys.SAVE_CANDIDATES_MISSING_GRADE_COUNT:
            return {
                ...state,
                numberOfCandidatesWithMissingGrade: action.count,
            };
        case actions.TypeKeys.CANDIDATE_SHARED:
            return {
                ...state,
                hasCandidateJustBeenShared: true,
            };
        case actions.TypeKeys.CANDIDATE_CONFIRMED:
            return {
                ...state,
                hasCandidateJustBeenConfirmed: true,
            };
        case actions.TypeKeys.CANDIDATE_UNSHARED:
            return {
                ...state,
                hasCandidateJustBeenUnshared: true,
            };
        case actions.TypeKeys.CANDIDATE_UNCONFIRMED:
            return {
                ...state,
                hasCandidateJustBeenUnconfirmed: true,
            };
        case actions.TypeKeys.APPROVE_ON_BEHALF:
            return {
                ...state,
                hasCandidateJustBeenSharedOnBehalf: true,
            };
        case actions.TypeKeys.UNNAPROVE_ON_BEHALF:
            return {
                ...state,
                hasCandidateJustBeenUnsharedOnBehalf: true,
            };
        case actions.TypeKeys.CONFIRM_ON_BEHALF:
            return {
                ...state,
                hasCandidateJustBeenConfirmedOnBehalf: true,
            };
        case actions.TypeKeys.UNCONFIRM_ON_BEHALF:
            return {
                ...state,
                hasCandidateJustBeenUnconfirmedOnBehalf: true,
            };
        case actions.TypeKeys.REOPEN_MARKING:
            return {
                ...state,
                hasCandidateJustBeenReopenMarking: true,
            };
        }
        return state;
    };
}
